"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://smartystreets.com/docs/cloud/us-street-api#footnotes
var ValidationFootnotes;
(function (ValidationFootnotes) {
    ValidationFootnotes["UNRECOGNISED_SECONDARY"] = "S";
    ValidationFootnotes["MISSING_SECONDARY"] = "H";
})(ValidationFootnotes = exports.ValidationFootnotes || (exports.ValidationFootnotes = {}));
var ValidationReason;
(function (ValidationReason) {
    ValidationReason["VALID"] = "VALID";
    ValidationReason["INVALID"] = "INVALID";
    ValidationReason["CLEAN_UP"] = "CLEAN_UP";
    ValidationReason["AMBIGUOUS"] = "AMBIGUOUS";
    ValidationReason["SECONDARY_ADD_MISSING"] = "SECONDARY_ADD_MISSING";
    ValidationReason["SECONDARY_ADD_UNRECOGNIZED"] = "SECONDARY_ADD_UNRECOGNIZED";
})(ValidationReason = exports.ValidationReason || (exports.ValidationReason = {}));
var ValidationCheckoutToggle;
(function (ValidationCheckoutToggle) {
    ValidationCheckoutToggle["MODAL"] = "TOGGLE_MODAL";
    ValidationCheckoutToggle["SECONDARY"] = "TOGGLE_SECONDARY";
    ValidationCheckoutToggle["INVALID"] = "TOGGLE_INVALID";
    ValidationCheckoutToggle["NONE"] = "TOGGLE_NONE";
})(ValidationCheckoutToggle = exports.ValidationCheckoutToggle || (exports.ValidationCheckoutToggle = {}));
var VerificationStatusInternational;
(function (VerificationStatusInternational) {
    VerificationStatusInternational["NONE"] = "None";
    VerificationStatusInternational["PARTIAL"] = "Partial";
    VerificationStatusInternational["AMBIGUOUS"] = "Ambiguous";
    VerificationStatusInternational["VERIFIED"] = "Verified";
})(VerificationStatusInternational = exports.VerificationStatusInternational || (exports.VerificationStatusInternational = {}));
var PrecisionLevel;
(function (PrecisionLevel) {
    PrecisionLevel["NONE"] = "None";
    PrecisionLevel["ADMINISTRATIVE_AREA"] = "AdministrativeArea";
    PrecisionLevel["LOCALITY"] = "Locality";
    PrecisionLevel["THOROUGHFARE"] = "Thoroughfare";
    PrecisionLevel["PREMISE"] = "Premise";
    PrecisionLevel["DELIVERY_POINT"] = "DeliveryPoint";
})(PrecisionLevel = exports.PrecisionLevel || (exports.PrecisionLevel = {}));
var AnalysisComponentChange;
(function (AnalysisComponentChange) {
    AnalysisComponentChange["VERIFIED_NO_CHANGE"] = "Verified-NoChange";
    AnalysisComponentChange["VERIFIED_ALIAS_CHANGE"] = "Verified-AliasChange";
    AnalysisComponentChange["VERIFIED_SMALL_CHANGE"] = "Verified-SmallChange";
    AnalysisComponentChange["VERIFIED_LARGE_CHANGE"] = "Verified-LargeChange";
    AnalysisComponentChange["ADDED"] = "Added";
    AnalysisComponentChange["IDENTIFIED_NO_CHANGE"] = "Identified-NoChange";
    AnalysisComponentChange["IDENTIFIED_ALIAS_CHANGE"] = "Identified-AliasChange";
    AnalysisComponentChange["IDENTIFIED_CONTEXT_CHANGE"] = "Identified-ContextChange";
    AnalysisComponentChange["UNRECOGNIZED"] = "Unrecognized";
})(AnalysisComponentChange = exports.AnalysisComponentChange || (exports.AnalysisComponentChange = {}));
var LanguageOptions;
(function (LanguageOptions) {
    LanguageOptions["LATIN"] = "latin";
})(LanguageOptions = exports.LanguageOptions || (exports.LanguageOptions = {}));
exports.precisionLevelHierarchy = {
    [PrecisionLevel.NONE]: 0,
    [PrecisionLevel.ADMINISTRATIVE_AREA]: 1,
    [PrecisionLevel.LOCALITY]: 2,
    [PrecisionLevel.THOROUGHFARE]: 3,
    [PrecisionLevel.PREMISE]: 4,
    [PrecisionLevel.DELIVERY_POINT]: 5,
};
//# sourceMappingURL=index.js.map